export enum mediaTypes {
  IMAGE = 'image',
  VIDEO = 'video',
  SOUND = 'sound',
  LINK = 'link',
}
